import React, { useEffect, useContext } from 'react';
import FundContext from '@/components/FundSingle/FundProvider';

const AllocationCircle: React.FC = () => {
  const { portfolio, currentTabIndex, hasInitCharts } = useContext(FundContext);

  // 1: 'US Stocks',
  // 2: 'Non US Stocks',
  // 3: 'Bonds',
  // 4: 'Cash',
  // 99: 'Other'
    
  var breakdownMapping = [];
  breakdownMapping[1] = {
    'name': 'Aktier',
    'color': '#001E63',
  };
  breakdownMapping[2] = {
    'name': 'Obligationer',
    'color': '#BBBBBB',
  };
  breakdownMapping[3] = {
    'name': 'Kontanter',
    'color': '#6F6F6F',
  }
  breakdownMapping[4] = {
    'name': 'Övrigt',
    'color': '#D2D2D2',
  };
  //breakdownMapping[99] = 'Miscellaneous';

  if (!portfolio || !portfolio.AssetAllocations) 
      return;

  const assetLocations = portfolio.AssetAllocations.filter((item: any) => {

    if (item.SalePosition !== 'N') {
      return false;
    }

    return true;
    
  })[0];

  useEffect(() => {

    function initAllocationCircleChart() {

      var chartData = [];
      var chartLabels = [];
      var chartColors = [];

      if (assetLocations) {
        // Loop through the asset locations and get the values
        for (let i = 0; i < assetLocations.BreakdownValues.length; i++) {
          const assetLocation = assetLocations.BreakdownValues[i];
          const type = assetLocation.Type;
          const value = assetLocation.Value;

          // Check if the breakdown is in the mapping
          if (breakdownMapping[type]) {
            chartData.push(value.toFixed(2));
            chartLabels.push(breakdownMapping[type].name);
            chartColors.push(breakdownMapping[type].color);
          }
        }
      }

      const chartConfig = {
        labels: chartLabels,
        datasets: [
          {
            data: chartData,
            backgroundColor: chartColors,
            borderColor: "white",
            borderWidth: 2,
          }
        ]
      };

      const chartOptions = {
        responsive: false,
        animation: { animateRotate: true, animateScale: true },
        plugins: {
            legend: {
              position: 'bottom',
              labels: {
                boxWidth: 10,
                boxHeight: 10,
                padding: 10,
                font: {
                  size: 12,
                  weight: 'bold'
                },
                usePointStyle: true,
                pointStyle: 'circle',
                useBorderRadius: true,
                borderRadius: 10,
              }
            }
        }
      };

      const config = {
        type: 'doughnut',
        data: chartConfig,
        options: chartOptions
      };

      const ctx = document.getElementById('allocationCircle') as HTMLCanvasElement;

      if (ctx) {
        new Chart(ctx, config);
      }
    }
    
    // Wait for the chartjs script to load
    if (hasInitCharts) {
            initAllocationCircleChart();
      } else {
          window.addEventListener('chartjsLoaded', () => {
              initAllocationCircleChart();
          });
      }

  }, [currentTabIndex, portfolio]);

  return <canvas id="allocationCircle"></canvas>;
};

export default AllocationCircle;
